import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const SPORTSMEN_DELETE_REQUEST = 'DELETE_SPORTSMEN_REQUEST';
export const SPORTSMEN_DELETE_FAILURE = 'DELETE_SPORTSMEN_FAILURE';
export const SPORTSMEN_DELETE_SUCCESS = 'DELETE_SPORTSMEN_SUCCESS';

export const deleteSportsman = (id) => {
    const params = [];
    params['id'] = id;
    return function(dispatch) {
        dispatch(deleteSportsmanRequest());
        return axios(apiRequestOptions(apiPath.SPORTSMEN.DELETE, null, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(deleteSportsmanSuccess(id));
                dispatch(addSuccessMessage('Sportsman successfully deleted'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(deleteSportsmanFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const deleteSportsmanRequest = () => ({type: SPORTSMEN_DELETE_REQUEST});

const deleteSportsmanFailure = error => ({
    type: SPORTSMEN_DELETE_FAILURE,
    error,
});

const deleteSportsmanSuccess = (sportsman) => ({
    type: SPORTSMEN_DELETE_SUCCESS,
    sportsman,
});
